import { map } from 'ramda';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { MenuRow, MenuTitle, WixIcons } from '../../../../components/common';
import { Layout } from '../../../../constants/Layout';
import { useTrackLayoutChange } from '../../../../utils/hooks/bi/useTrackLayoutChange';
import styles from './LayoutSwitcherMenu.scss';
import { IOuter } from './LayoutSwitcherMenu.types';

const menuProps = {
  [Layout.Gallery]: {
    icon: <WixIcons.LayoutGallerySmall />,
    text: <FormattedMessage id="layout-switcher.gallery" />,
    dataHook: 'layout-switcher-gallery',
  },
  [Layout.List]: {
    icon: <WixIcons.LayoutListSmall />,
    text: <FormattedMessage id="layout-switcher.list" />,
    dataHook: 'layout-switcher-list',
  },
};

export const LayoutSwitcherMenu: FC<IOuter> = ({ layout, layouts, onLayoutChange, tabName }) => {
  const { trackLayoutChange } = useTrackLayoutChange(tabName);

  const handleLayoutChange = (newLayout) => () => {
    trackLayoutChange(layout, newLayout);
    onLayoutChange(newLayout);
  };

  return (
    <>
      <MenuTitle text={<FormattedMessage id="layout-switcher.menu-title" />} />

      {map(
        (optionLayout) => (
          <MenuRow
            key={optionLayout}
            className={styles.layoutSwitcherMenu}
            active={layout === optionLayout}
            {...menuProps[optionLayout]}
            onClick={handleLayoutChange(optionLayout)}
          />
        ),
        layouts,
      )}
    </>
  );
};
